/**
 * Copyright (C) 2017-, Optio3, Inc. All Rights Reserved.
 *
 * Proprietary & Confidential Information.
 *
 * CoreStack External API
 * No description provided (generated by Swagger Codegen https://github.com/swagger-api/swagger-codegen)
 *
 * OpenAPI spec version: 1.0.0
 *
 *
 * NOTE: This class is auto generated by the swagger code generator program.
 * https://github.com/swagger-api/swagger-codegen.git
 * Do not edit the class manually.
 */

import * as models from './models';

export class AnnotationRange {
    getFixupPrototypeFunction() { return AnnotationRange.fixupPrototype; }

    static newInstance(model: Partial<AnnotationRange>): AnnotationRange {
        let obj = Object.assign(new AnnotationRange(), model);
        AnnotationRange.fixupPrototype(obj);
        return obj;
    }

    static deepClone(model: Partial<AnnotationRange>): AnnotationRange {
        if (!model) return null;
        return AnnotationRange.newInstance(<AnnotationRange> JSON.parse(JSON.stringify(model)));
    }

    static fixupPrototype(obj: AnnotationRange) {
        if (!obj) return;

        models.AnnotationRange.setPrototype(obj);

        obj.fixupFields();
    }

    protected static setPrototype(obj: AnnotationRange): boolean {
        Object.setPrototypeOf(obj, AnnotationRange.prototype);
        return false; // Not a polymorphic type, okay to overwrite the prototype.
    }

    fixupFields() {
        if (this.start_offset === undefined) {
            this.start_offset = 0;
        }
        if (this.end_offset === undefined) {
            this.end_offset = 0;
        }
    }

    /**
     * Id of the element containing the selection start
     */
    start_element_id: string;

    /**
     * Character offset of the selection start within that element's text
     */
    start_offset: number;

    /**
     * Id of the element containing the selection end
     */
    end_element_id: string;

    /**
     * Character offset of the selection end within that element's text
     */
    end_offset: number;

}
